module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.5-offline.ff9994e3.png";